module.exports = __webpack_public_path__ + "static/media/whatsapp-icon.f6b36797.webp";